import { Theme } from '@material-ui/core/styles';

export const getMuiChip = (theme: Theme): Record<string, unknown> => ({
  MuiChip: {
    root: {
      padding: theme.spacing(0, 1),

      '&:hover': {
        borderColor: theme.palette.primary.main,
      },

      '&.MuiChip-clickable.MuiChip-outlined:hover, &.MuiChip-clickable.MuiChip-outlined:focus, &.MuiChip-deletable.MuiChip-outlined:focus':
        {
          backgroundColor: 'transparent',
        },
    },

    label: {
      alignItems: 'center',
      color: theme.palette.text.primary,
      display: 'flex',
      padding: 0,
    },

    outlined: {
      backgroundColor: 'transparent',
      border: `1px solid ${theme.palette.grey[400]}`,
    },
  },
});
